export enum OfferQualifierTypes {
  ProductValuedAtleast = 1,
  PurchaseAmount = 2,
  SpendPoints = 3,
  LifetimePoints = 4,
  PurchaseProduct = 5,
}
